import { z } from 'zod';
import { requireFields, yesNo, yesNoRequired } from '@utils/form-schema';

const YES = '1';

export const pendingSurgerySchema = z
    .object({
        hasBeenScheduled: yesNoRequired,
        scheduledDateTime: z.string(),
        hasCompleted: yesNo,
        treatment: z.string(),
        convenience: z.string(),
        facility: z.string(),
        commendations: z.string(),
        comments: z.string(),
    })
    .superRefine((data, ctx) => {
        if (data.hasBeenScheduled === YES) {
            requireFields(ctx, data, 'scheduledDateTime', 'hasCompleted');

            if (data.hasCompleted === YES) {
                requireFields(ctx, data, 'treatment', 'convenience', 'facility', 'commendations', 'comments');
            }
        }
    });
